var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2526 16.4167H18.6693L17.1473 14.8947C16.7345 14.4819 16.5026 13.9221 16.5026 13.3383V9.91667C16.5026 7.08653 14.6939 4.67885 12.1693 3.78653V3.41667C12.1693 2.22005 11.1992 1.25 10.0026 1.25C8.80599 1.25 7.83594 2.22005 7.83594 3.41667V3.78653C5.31135 4.67885 3.5026 7.08653 3.5026 9.91667V13.3383C3.5026 13.9221 3.27071 14.4819 2.85795 14.8947L1.33594 16.4167H6.7526M13.2526 16.4167V17.5C13.2526 19.2949 11.7975 20.75 10.0026 20.75C8.20768 20.75 6.7526 19.2949 6.7526 17.5V16.4167M13.2526 16.4167H6.7526",
    stroke: "#2667B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIconBlue);
export default __webpack_public_path__ + "static/media/notification_icon_blue.586967770628e9ca3b59731f8caf5402.svg";
export { ForwardRef as ReactComponent };